import React from "react";
import ProfileLayout from "../../components/layout/ProfileLayout";
import HelpHome from "./components/HelpHome";

const HelpSection = () => {
  return (
    <ProfileLayout>
      <HelpHome />
    </ProfileLayout>
  );
};

export default HelpSection;
